import axios, { AxiosResponse } from 'axios';
import { nearestTagName } from './nearest-parent';

export class CurriculumDownload {
    private selectAllCheckbox: HTMLInputElement;
    private selectAllResourcesCheckbox: HTMLInputElement;
    private sections: HTMLCollectionOf<HTMLInputElement>;
    private images: HTMLCollectionOf<HTMLInputElement>;
    private downloadButton: HTMLButtonElement;
    private form: HTMLFormElement;
    private unique: HTMLInputElement;

    constructor() {
        this.selectAllCheckbox = document.getElementById("allSections") as HTMLInputElement;
        this.selectAllResourcesCheckbox = document.getElementById("allResources") as HTMLInputElement;
        this.sections = document.getElementsByClassName("curriculum-section-js") as HTMLCollectionOf<HTMLInputElement>;
        this.images = document.getElementsByClassName("curriculum-image-js") as HTMLCollectionOf<HTMLInputElement>;
        this.downloadButton = document.getElementsByClassName("btn-curriculum-download-js")[0] as HTMLButtonElement;
        this.form = nearestTagName(this.downloadButton, "form") as HTMLFormElement;
        this.unique = document.getElementById("unique") as HTMLInputElement;

        this.disableDownload();
    }

    private iterateSections(func: (section: HTMLInputElement) => any) {
        for (let i = 0; i < this.sections.length; ++i) {
            func(this.sections[i]);
        }
    }

    private iterateImages(func: (section: HTMLInputElement) => any) {
        for (let i = 0; i < this.images.length; ++i) {
            func(this.images[i]);
        }
    }

    private iterateCheckboxes(func: (section: HTMLInputElement) => any) {
        this.iterateSections(func);
        this.iterateImages(func);
    }

    setupListeners() {
        if (this.selectAllCheckbox != null) {
            this.selectAllCheckbox.addEventListener("change", event => {
                this.checkAllSections(this.selectAllCheckbox.checked);
                this.checkDownloadButton();
            });
        }

        if (this.selectAllResourcesCheckbox != null) {
            this.selectAllResourcesCheckbox.addEventListener("change", event => {
                this.checkAllResources(this.selectAllResourcesCheckbox.checked);
                this.checkDownloadButton();
            });
        }

        this.iterateCheckboxes(section => {
            if (section != null) {
                section.addEventListener("change", event => {
                    this.checkDownloadButton();
                });
            }
        });

        if (this.downloadButton != null) {
            this.downloadButton.addEventListener("click", (evt: MouseEvent) => {
                this.submitDownloadRequest();
            });
        }
    }

    submitDownloadRequest() {

        this.disableDownload();
        this.downloadButton.innerText = "Downloading...";
        // We don't really care about the result, if it returns something, disable the download button.
        axios.get<string>(`/umbraco/Surface/DownloadCurriculumSurface/CheckPdf?pageId=${this.downloadButton.getAttribute("data-page-id")}&unique=${this.unique.getAttribute("value")}`, { withCredentials: true }).then(() => {
            this.enableDownload();
            this.downloadButton.innerText = "Download";
        }).catch(() => {
            this.enableDownload();
            this.downloadButton.innerText = "Download";
        });
        this.form.submit();
    }

    checkAllSections(to: boolean) {
        this.iterateSections(section => {
            section.checked = to;
        });
    }

    checkAllResources(to: boolean) {
        this.iterateImages(section => {
            section.checked = to;
        });
    }

    checkDownloadButton() {
        let canDownload = false;

        this.iterateCheckboxes(section => {
            if (section.checked) {
                canDownload = true;
            }
        });

        if (canDownload)
            this.enableDownload();
        else
            this.disableDownload();
    }
     
    disableDownload() {
        if (this.downloadButton != null) {
            if (!this.downloadButton.getAttribute("disabled"))
                this.downloadButton.setAttribute("disabled", "disabled");
        }
    }

    enableDownload() {
        if (this.downloadButton != null) {
            if (this.downloadButton.getAttribute("disabled"))
                this.downloadButton.removeAttribute("disabled");
        }
    }
}

var checkboxes = new CurriculumDownload();
checkboxes.setupListeners();

export default checkboxes;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/curriculum-download.ts